import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { AccordionProps } from './types'

export const AccordionWrapper = styled(Flex)<AccordionProps>`
  user-select: none;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  background-color: ${props => props.bgColorTransparent ? 'transparent' : props.theme.colors.shades.neutral[1]};
  color: ${props => props.theme.colors.main.dark};
  ${props => props.margin && css`
    margin: ${props.margin};
  `}
  ${props => props.gridArea && css`
    grid-area: ${props.gridArea};
  `}
`

export const AccordionTitle = styled(Flex)`
  cursor: pointer;
  padding: 20px;
`

export const AccordionContent = styled.div`
  padding: 0px 20px 20px 20px;
  user-select: text;
`
